import { isArray } from '@antv/util';
/** @ignore */
export function parseFields(field) {
    if (isArray(field)) {
        return field;
    }
    return field.split('*');
}
//# sourceMappingURL=parse-fields.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2@4.0.15@@antv/g2/esm/geometry/util/parse-fields.js
// module id = null
// module chunks = 